import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router';

import { RoutesPreenchimento, RoutesGerenciamento } from 'routes';
import {
  AuthProvider,
  FormProvider,
  PageProvider,
  ThemeProvider,
} from 'context';
import { ErroValidaLink } from 'pages';

const App: React.FC = () => (
  <Router>
    <Routes>
      <Route
        path="/:id"
        element={
          <ThemeProvider>
            <PageProvider>
              <AuthProvider>
                <FormProvider>
                  <RoutesPreenchimento />
                </FormProvider>
              </AuthProvider>
            </PageProvider>
          </ThemeProvider>
        }
      />
      <Route
        path="/visualizar-documento/:id"
        element={
          <ThemeProvider>
            <PageProvider>
              <AuthProvider>
                <RoutesGerenciamento />
              </AuthProvider>
            </PageProvider>
          </ThemeProvider>
        }
      />
      <Route path="*" element={<ErroValidaLink />} />
    </Routes>
  </Router>
);

export default App;
